import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanBetWayWinData, SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { IAllWinData } from "../../../server/data/ISanServerData";
import { WinCounter } from "../../independent/countup/WinCounter";
import { TimelineMax } from "gsap";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { Revealer } from "../../independent/revealer/Revealer";
import { SanParsedInitData } from "../../../server/data/SanParsedInitData";
import { PosterManager, NoWinPosterState } from "../../independent/poster/PosterManager";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanBackground } from "../../background/SanBackground";
import { XWaysCounter } from "../../independent/countup/XWaysCounter";
import { ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { JurisdictionNames } from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";
import { SanGameConfig } from "../../../SanGameConfig";

export class IdleWinPresentation extends Presentation {
    private featurePlayed:boolean = false;

    private  _gameData:SanParsedGameData;
    private _allHits:IAllWinData;
    private _idleTimeline:TimelineMax | null;

    private _totalWin:number = 0;

    private static _noWinPosterIndex:number = 0;

    private _triggerNoWin:number = 0;
    private triggerValue:number = 9;

    private static _noPosters:string[] = [
        NoWinPosterState.NO_WIN_PAPER,
        NoWinPosterState.NO_WIN_CIGS,
        NoWinPosterState.NO_WIN_INSANE,
        NoWinPosterState.NO_WIN_AGAIN,
        NoWinPosterState.NO_WIN_SHIT,
        NoWinPosterState.NO_WIN_BREAD
    ] 

    private static _noPostersItaly:string[] = [
        NoWinPosterState.NO_WIN_PAPER +"_ITALY",
        NoWinPosterState.NO_WIN_CIGS,
        NoWinPosterState.NO_WIN_INSANE,
        NoWinPosterState.NO_WIN_AGAIN + "_ITALY",
        NoWinPosterState.NO_WIN_SHIT,
        NoWinPosterState.NO_WIN_BREAD
    ] 

    public checkForActivation(data:SanParsedGameData):boolean{ return data.nextMode == GameMode.NORMAL; }

    public static get getNextNoPoster():string{
        const juriArray:string[] = SlotGame.api.gameClientConfiguration.jurisdictionName === JurisdictionNames.ITALY ? this._noPostersItaly : this._noPosters ;
        
        return juriArray[this._noWinPosterIndex%juriArray.length];
    }

    public setParsedInitData(data:SanParsedInitData):void{
        if(data.mode == GameMode.NORMAL && data.nextMode == GameMode.NORMAL)
            this.PresentationState.set(PresentationState.ACTIVATED);
        
    }

    public setParsedGamedData(data:SanParsedGameData){
        this.featurePlayed = (data.mode != GameMode.NORMAL && data.nextMode == GameMode.NORMAL);
        this._gameData = data;
        this._allHits = data.allWinData;
        this._totalWin = data.totalWin;

        if(data.isRealBigwin || this.featurePlayed) this._triggerNoWin = 0;

        if(data.singleWin == 0 && data.mode == GameMode.NORMAL){
            let wildCount:number = 0;
            let mysteryCount:number = 0;

            if(data.wildAmount > 2){
                this._triggerNoWin += 2;
            }
            else if(data.scatterAmount == 2){
                this._triggerNoWin += 3;
            }
            else if(wildCount + mysteryCount == 3){
                this._triggerNoWin += 5;
            }
            else if(wildCount + mysteryCount > 3){
                this._triggerNoWin += this.triggerValue;
            }
            else{
                this._triggerNoWin++;
            }
        }else{
            this._triggerNoWin = this._triggerNoWin - 2 <= 0 ? 0 : this._triggerNoWin-2;
        }
    }

    private static boomGame():void{
        if(!this._blowMyGame){
            this._blowMyGame = new TimelineMax({
            repeat:-1,
            repeatDelay:0,
            onRepeat:() =>{
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
                if(ResizeHelper.resizeData) EventHandler.dispatchEvent(new GameEvent(StageEvent.STAGE_RESIZED,ResizeHelper.resizeData));
                // if(PunkEngineManager.isPlaying) EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP));
            }
        })
        this._blowMyGame.to(this,0.01,{});
        this._blowMyGame.play();
        }
    }

    private static _blowMyGame:TimelineMax;

    public getPresentation():void {
    
   
        // if(!IdleWinPresentation._blowMyGame){
        //     IdleWinPresentation.boomGame();
        // }

        this.PresentationState.set(PresentationState.END);

        SanBackground.instance.restoreOverlay(3);
        RevealerManager.resetIdle();
        SanEngineManager.onBeforeSpinStart();

        if(this._gameData) XWaysCounter.instance.setValue(undefined,this._gameData.rawData.totalWays,0.15);
        if(this._triggerNoWin >= this.triggerValue){

            this.pTimeline.add(PosterManager.instance.play(NoWinPosterState.NO_WIN,undefined,{config:{
                animationName: IdleWinPresentation.getNextNoPoster, duration: 3.5
            }}));

            PosterManager.instance.setInteractive(true);

            this.pTimeline.add(() => {
                PosterManager.instance.stop();
                PosterManager.instance.setInteractive(false);
            });

            this._triggerNoWin = 0;
            IdleWinPresentation._noWinPosterIndex++;
        }

        if(this._allHits && this._allHits.longest > 0 && !SanGameConfig.instance.WIN_BELOW_STAKE){
            this.pTimeline.add(() => this.addWinCountUpToTimeline(),0.5);
        }
        else{
            SanEngineManager.RSWindow((Reel:number,sym:number) => {
                const revExpanded:boolean = RevealerManager.getTopBar(Reel).isExpanded && RevealerManager.getBotBar(Reel).isExpanded;
                if(!revExpanded) SanEngineManager.getReel(Reel).getSymbol(sym)?.setInteractive(true)
            });
            RevealerManager.getAllBars().forEach(r => r.setInteractive(true));
        }
    }

    private isDoubleExpWin(reelPos:number ,row:boolean[]):boolean{
        const revExpanded:boolean = RevealerManager.getTopBar(reelPos).isExpanded &&  RevealerManager.getBotBar(reelPos).isExpanded;
        const hits:boolean = row[0] && row[row.length-1];

        return revExpanded && hits;
    }

    protected addWinCountUpToTimeline():void {

        this._idleTimeline = new TimelineMax({
            repeat: -1,
            repeatDelay: 0,
        });
        const delay:number = 2;
        const duration:number = 1.2;
        this._idleTimeline.to(this,2,{});
        this._idleTimeline.add(() => WinCounter.normalCounter.alpha = 1, delay)

        const winGrps:SanBetWayWinData[] = this._gameData.sanBetWays!;
        
        // Start Wins
        for(let groups = 0; groups < winGrps.length;groups++){
            const winData:SanBetWayWinData = winGrps[groups];
            
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                let doubleExpWin:boolean = this.isDoubleExpWin(reel,posRow);
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row]){
                        if(row == 0 || row == this._gameData.allWinData.reelWinPositions[reel].length-1){
                            const bar:Revealer = row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                            this._idleTimeline.add( () => bar.idleWinAnimation(duration,winData.reelWinLvlPositions[reel][row]),delay + (groups*duration))
                        }
                        else if(!doubleExpWin){
                            this._idleTimeline.add(() => SanEngineManager.getReel(reel).getSymbol(row-1)!.changeState(
                                { state: ReelSymbolStates.IDLE, duration: duration, type:winData.reelWinLvlPositions[reel][row] })
                            ,delay + (groups*duration));
                        }
                    }
                }
            }
            this._idleTimeline.add([
                () => WinCounter.normalCounter.showCounter(winData.amount,winData.numberOfCombinations),
            ],delay + (groups*duration))
        }

        if(winGrps.length > 1){
            for(let reel = 0; reel < this._allHits.reelWinPositions.length; reel++){
                let posRow:boolean[] = this._allHits.reelWinPositions[reel];
                let doubleExpWin:boolean = this.isDoubleExpWin(reel,posRow);
                for(let row = 0; row < this._allHits.reelWinPositions[reel].length;row++){
                    if(this._allHits.reelWinPositions[reel][row]){
                        if(row == 0 || row == this._allHits.reelWinPositions[reel].length-1){
                            const bar:Revealer = row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                            this._idleTimeline.add( () => bar.idleWinAnimation(duration,this._allHits.biggestWinLvl),delay + (winGrps.length*duration))  
                        }else if(!doubleExpWin){
                            this._idleTimeline.add(() => SanEngineManager.getReel(reel).getSymbol(row-1)!.changeState(
                                { state: ReelSymbolStates.IDLE, duration: duration, type: this._allHits.biggestWinLvl })
                            ,delay + (winGrps.length*duration));
                        }
                    }
                }
            }
        }

        this._idleTimeline.add([
            () => WinCounter.normalCounter.idleStop(this._gameData.singleWin,this._gameData.allWinData.totalWinCombination),
        ], delay + (winGrps.length == 1 ? 0 : (winGrps.length*duration)));
        this._idleTimeline.to(this,delay ,{} );
        this._idleTimeline.play();
    }

    skipPresentation():void{
        if(!this.PresentationState.equal(PresentationState.INACTIVE))
            this.pTimeline.totalProgress(1);
    }

    public stopPresentation():void{
    }

    public endPresentation():void {
        this.PresentationState.set(PresentationState.INACTIVE);

        RevealerManager.getAllBars().forEach(r => r.setInteractive(false));
        SanEngineManager.RSWindow((Reel:number,sym:number) => SanEngineManager.getReel(Reel).getSymbol(sym)?.setInteractive(false));

        if(this._totalWin && this._idleTimeline && this._idleTimeline.isActive()){
            WinCounter.normalCounter.abort(this._gameData!.singleWin);
        }

        this._idleTimeline = Helper.timeLineNuller(this._idleTimeline);
        
        const bars:Revealer[] = RevealerManager.getAllBars();
        let expandDelay:number = 0;

        for(let i =0; i < bars.length;i++){
            if(bars[i].isExpanded){
                expandDelay = this.pTimeline.add(bars[i].expandRes(false),0).duration();
            }
        }
        let barActivated:boolean = false;
        for(let i =0; i < bars.length;i++){
            if(bars[i].isActive){
                this.pTimeline.add(bars[i].closeBar(), expandDelay);
                barActivated = true;
            } 
        }

        if(barActivated) XWaysCounter.instance.setValue(undefined,243,0.2);
        
        this.pTimeline.to(this,0.1,{});
    }
}